import { Info } from 'lucide-react';
import React from 'react';
import {
    Tooltip as UiTooltip,
    TooltipContent,
    TooltipTrigger
} from '@components/ui/tooltip';

interface TooltipProps {
    title: React.ReactNode;
    children?: React.ReactElement;
    hideIcon?: boolean;
}

export const Tooltip = ({ title, children, hideIcon }: TooltipProps) => (
    <UiTooltip>
        <TooltipTrigger asChild>
            <span className="inline-flex items-center gap-1">
                {!hideIcon && <Info className="size-4 text-muted-foreground" />}
                {children}
            </span>
        </TooltipTrigger>
        <TooltipContent side="top" align="start">
            {title}
        </TooltipContent>
    </UiTooltip>
);
